var React = require('react');

function Water (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.3","d":"M22.3166 16.25C22.3166 17.4417 21.2874 18.4167 20.0416 18.4167C18.7958 18.4167 17.7666 17.4417 17.7666 16.25C17.7666 15.0583 20.0416 13 20.0416 13C20.0416 13 22.3166 15.0583 22.3166 16.25Z","fill":"#0A9828","key":0}),React.createElement("path",{"d":"M16.0332 7.58333C14.2999 7.58333 12.7291 8.23333 11.5374 9.2625V5.41667H14.1916V3.25H7.1499V5.41667H9.2624V14.0833V15.7083V20.5833V22.75H11.5374V20.5833V14.0833C11.5374 11.7 13.5416 9.75 16.0332 9.75C17.2249 9.75 18.3624 10.1833 19.2291 10.9958L20.7999 9.47917C19.5541 8.23333 17.8207 7.58333 16.0332 7.58333Z","fill":"#0A9828","key":1})]);
}

Water.defaultProps = {"viewBox":"0 0 26 26","fill":"none"};

module.exports = Water;

Water.default = Water;
